import React from 'react'

export const IconTours = () => {
  return (
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.59052 5.36686C3.52385 1.33019 9.60219 1.33019 10.5239 5.36686C11.0722 7.73519 9.56719 9.74186 8.26052 10.9902C7.30385 11.9002 5.79885 11.8885 4.84219 10.9902C3.54719 9.74186 2.04219 7.73519 2.59052 5.36686Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M17.7574 19.3669C18.6908 15.3302 24.8041 15.3302 25.7374 19.3669C26.2858 21.7352 24.7808 23.7419 23.4624 24.9902C22.5058 25.9002 20.9891 25.8885 20.0324 24.9902C18.7141 23.7419 17.2091 21.7352 17.7574 19.3669Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M14.1758 5.8335H17.3024C19.4608 5.8335 20.4641 8.50516 18.8424 9.9285L9.52076 18.0835C7.89909 19.4952 8.90242 22.1668 11.0491 22.1668H14.1758"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.57612 6.41683H6.5896"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7431 20.4168H21.7566"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
